export enum AdOrderItemStatus {
  /** Черновик, созданный владельцем */
  DRAFT_OWNER = 'draft_owner',

  /** Ожидает размещения объявления */
  AWAITING_PLACEMENT = 'awaiting_placement',

  /** Ожидает подтверждения */
  AWAITING_CONFIRMATION = 'awaiting_confirmation',

  /** Ожидает установки даты размещения рекламодателем */
  AWAITING_SETTINGS_DATE_PLACEMENT = 'awaiting_settings_date_placement',

  /** Отклонено */
  DECLINED = 'declined',

  /** Объявление публикуется */
  PUBLISHING = 'publishing',

  /** Объявление опубликовано */
  PUBLISHED = 'published',

  /** Заявка полностью обработана */
  COMPLETE = 'complete',

  /** Ошибка при публикации */
  FAILED = 'failed',
}
